import template from '../../templates/companies/Company.ejs';
import loader from 'helpers/loader';
import modal from 'helpers/modal';
import Alerts from 'lib/alerts';

module.exports = Backbone.View.extend({
    tagName: 'tr',
    events: {
        'click .js-login-to-company': 'loginToCompany',
        'click .js-discount-save': 'updateDiscount',
        'click .js-update-subs': 'forceSubsUpdate',
        'click .js-generate-invoices': 'generateInvoices',
        'click .js-toggle-invoicing': 'toggleInvoicing',
        'click .js-update-details': 'updateDetails',
        'click .js-remove-company': 'removeCompany',
        'click .js-yearly-adjust': 'yearlyAdjust',
        'change .js-ext-mppAdmin': 'updateMPP'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            attachments: null,
            discountCodes: []
        });
        this.model.on('sync', this.render, this);

        this.model.fetchSubscription()
            .then(() => this.render());

        return this;
    },

    render: function() {
        this.$el.html(template({
            model: this.model,
            subscription: this.model.getSubscription(),
            mppAdmins: this.options.mppAdmins,
            discountCodes: this.options.discountCodes
        }));

        return this;
    },

    updateDiscount(ev) {
        ev.preventDefault();
        const discountName = this.$('input[name="discount"]').val();
        const isDiscountLimited = this.$('input[name="isDiscountLimited"]')
            .prop('checked');
        const discountLimit = this.$('input[name="discountLimit"]').val();
        const stopLoader = loader.startFullScreen();
        const subscription = this.model.getSubscription();

        if (!discountName) {
            subscription.set({
                couponCode: ''
            });
        } else {
            const discountCode = this.options.discountCodes
                .find(code => [
                    // jscs:disable
                    code.invoice_name, code.name
                ].includes(discountName));

            if (!discountCode) {
                modal.warning({
                    text: `Invalid discount specified. Please choose \
                    from the dropdown list`
                });
                return stopLoader();
            }

            subscription.set({
                couponCode: discountCode.id
            });
        }

        subscription.set({
            isDiscountLimited: isDiscountLimited,
            discountLimit: parseInt(discountLimit, 10) || 0
        });
        subscription.save()
            .then(() => this.render())
            .then(() => {
                modal.showAlertSuccess('The discount has been updated');
            })
            .catch(err => modal.showError(JSON.stringify(err)))
            .finally(stopLoader);
    },

    updateMPP: function(ev) {
        let $el = this.$(ev.currentTarget);
        let mppAdmin = this.options.mppAdmins
            .find(u => u.id == $el.val()) || null;
        let promise = Promise.resolve();

        if (mppAdmin) {
            promise = this.model.setMPPAdmin(mppAdmin.id);
        } else {
            promise = this.model.unsetMPPAdmin();
        }

        this.$('.discount-inputs').toggleClass('discount-inputs', !!mppAdmin);

        promise.then(() => {
            modal.showAlertSuccess(
                'Settings for MPP Admin have been saved'
            );
        })
        .catch(err => {
            Alerts.show('error', {text: JSON.stringify(err)});
        });
    },

    loginToCompany: function() {
        window.open(`/?company=${this.model.get('objectId')}`, '_blank');
        return false;
    },

    forceSubsUpdate: function(ev) {
        ev.preventDefault();
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);
        this.model.getSubscription().updateStatus()
            .then(() => stopLoader())
            .catch(err => {
                stopLoader();
                modal.showError(`Error: ${JSON.stringify(err)}`, false);
            });
    },

    generateInvoices: function(ev) {
        ev.preventDefault();
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);
        this.model.getSubscription().generateInvoices()
            .then(() => stopLoader())
            .catch(err => {
                stopLoader();
                modal.showError(`Error: ${JSON.stringify(err)}`, false);
            }
        );
    },

    toggleInvoicing: function(ev) {
        ev.preventDefault();
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);
        this.model.getSubscription().toggleInvoicing()
            .then(stopLoader)
            .then(() => this.render())
            .catch(err => {
                stopLoader();
                modal.showError(`Error: ${JSON.stringify(err)}`, false);
            });
    },

    updateDetails: function(ev) {
        ev.preventDefault();
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);
        this.model.getSubscription().updateDetails()
            .then(stopLoader)
            .catch(err => {
                stopLoader();
                modal.showError(`Error: ${JSON.stringify(err)}`, false);
            }
        );
    },

    removeCompany: function(ev) {
        ev.preventDefault();

        let $button = this.$(ev.currentTarget);
        Alerts.show('confirm', {
            title: 'Remove company',
            text: `Are you sure you want to remove ` +
                `"${this.model.get('companyName') ||
                    this.model.get('contactName')}"?`
        }).then(() => {
            let stopLoader = loader.startFullScreen($button);
            this.model.destroy()
                .then(() => window.location.reload())
                .catch(err => {
                    modal.showError(`Error: ${JSON.stringify(err)}`, false);
                })
                .finally(() => stopLoader());
        });
    },

    yearlyAdjust: function(ev) {
        ev.preventDefault();
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);
        this.model.getSubscription().adjustYearlyInvoice()
            .then(() => stopLoader())
            .catch(err => {
                stopLoader();
                modal.showError(`Error: ${JSON.stringify(err)}`, false);
            }
        );
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/companies/Company.js